// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InteractivePodsGrid_wrapper__eGVvT"};